<template>
  <div id="app" class="min-h-screen bg-gray-100 dark:bg-gray-900 antialiased">
    <div v-if="!initialized" class="flex min-h-screen items-center justify-center">
      <div class="text-center">
        <div class="mb-4 inline-block h-8 w-8 animate-spin rounded-full border-b-2 border-blue-600"></div>
        <p class="text-gray-600 dark:text-gray-400">Loading...</p>
      </div>
    </div>

    <router-view v-else-if="!isAuthenticated" />

    <div v-else class="flex h-screen overflow-hidden">
      <aside class="hidden w-64 flex-shrink-0 border-r border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800 md:block">
        <div class="flex h-full flex-col">
          <div class="flex h-16 items-center justify-between border-b border-gray-200 px-4 dark:border-gray-700">
            <div class="flex items-center gap-3">
              <img src="/deepchat-logo.svg" alt="" class="h-9 w-9 object-contain" />
              <div>
              <h1 class="text-lg font-semibold text-gray-900 dark:text-white">Super Admin</h1>
              <p class="text-xs text-gray-500 dark:text-gray-400">Platform control</p>
              </div>
            </div>
          </div>

          <nav class="flex-1 space-y-1 px-2 py-4">
            <router-link
              v-for="item in adminSidebarItems"
              :key="item.id"
              :to="{ path: '/admin', query: { tab: item.id } }"
              class="flex items-center rounded-md px-3 py-2 text-sm font-medium transition-colors"
              :class="$route.path === '/admin' && activeAdminTab === item.id
                ? 'bg-blue-50 text-blue-700 dark:bg-blue-900 dark:text-blue-200'
                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white'"
            >
              {{ item.label }}
            </router-link>
          </nav>

          <div class="border-t border-gray-200 p-4 dark:border-gray-700">
            <p class="truncate text-sm font-medium text-gray-900 dark:text-white">
              {{ user?.firstName }} {{ user?.lastName }}
            </p>
            <p class="truncate text-xs text-gray-500 dark:text-gray-400">{{ user?.email }}</p>
            <button
              @click="logout"
              class="mt-3 w-full rounded-md border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700"
            >
              Logout
            </button>
            <p class="mt-3 text-[11px] text-gray-400 dark:text-gray-500">
              Admin v1.0.1
            </p>
          </div>
        </div>
      </aside>

      <main class="flex-1 overflow-y-auto">
        <header class="flex h-16 items-center justify-between border-b border-gray-200 bg-white px-4 dark:border-gray-700 dark:bg-gray-800 md:hidden">
          <div class="flex items-center gap-3">
            <img src="/deepchat-logo.svg" alt="" class="h-8 w-8 object-contain" />
            <div>
            <h1 class="text-base font-semibold text-gray-900 dark:text-white">Super Admin</h1>
            <p class="text-xs text-gray-500 dark:text-gray-400">{{ user?.email }}</p>
            </div>
          </div>
          <button @click="logout" class="rounded-md border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:text-gray-200">
            Logout
          </button>
        </header>
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from './stores/auth'

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()

const adminSidebarItems = [
  { id: 'companies', label: 'Companies' },
  { id: 'models', label: 'AI Models' },
  { id: 'email', label: 'Email' },
  { id: 'templates', label: 'Templates' },
  { id: 'payments', label: 'Payments' }
]

const initialized = computed(() => authStore.initialized)
const isAuthenticated = computed(() => authStore.isAuthenticated)
const user = computed(() => authStore.user)
const activeAdminTab = computed(() => {
  const tab = typeof route.query.tab === 'string' ? route.query.tab : 'companies'
  return adminSidebarItems.some((item) => item.id === tab) ? tab : 'companies'
})

const logout = async () => {
  await authStore.logout()
  router.push('/login')
}
</script>
